import {
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles({
  formularioCorpo: {
    position: 'relative',
    backgroundColor: '#fff',
    maxWidth: '555px',
    width: '100%',
    boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    padding: 15,
    marginTop: '94px',
    marginBottom: '198px',
    minHeight: '332px',
  },
  input: {
    margin: 0,
    height: 42,
    backgroundColor: 'white',
  },
  inputDisabled: {
    margin: 0,
    height: 42,
    backgroundColor: '#fffae6',
  },
  inputBorda: {
    margin: 0,
    height: 42,
    border: 'solid 1px #c2c4d1',
    borderRadius: 4,
    backgroundColor: 'white',
  },
  textoLabel: {
    fontFamily: 'IBM Plex Sans',
    color: '#0430ad',
    fontWeight: 500,
    fontSize: 14,
    margin: 0,
  },
  textoLabelLink: {
    fontFamily: 'IBM Plex Sans',
    color: '#0430ad',
    fontWeight: 500,
    fontSize: 12,
    margin: 0,
    paddingTop: 2,
  },
  select: {
    padding: 0,
    fontSize: 14,
    height: 42,
    backgroundColor: 'white',
  },
  selectDisabled: {
    padding: 0,
    fontSize: 14,
    height: 42,
    backgroundColor: '#f7f7fa',
  },
  botaoConfirmar: {
    borderRadius: 6,
    backgroundColor: '#044ada',
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    color: 'white',
    border: 'none',
    padding: '0.5rem',
  },
  cabecalho: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  formularioTitulo: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784',
    textTransform: 'uppercase'

  },
  avatar: {
    width: 88,
    height: 88,
    border: 'solid 1.8px #dfdfe6',
  },
  botaoAvatar: {
    borderRadius: 6,
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    border: 'solid 1px #97c1ff',
    color: '#044ada',
    marginTop: 10,
  },
  campoOnDrag: {
    border: 'dashed 2px #cdcdcd',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    alignItems: 'center',
  },
  campoOnDragAtivo: {
    border: 'dashed 2px #cdcdcd',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    alignItems: 'center',
    backgroundColor: '#A8CFFF',
  },
  dropIcon: {
    fontSize: 36,
    color: '#30b0ff',
  },
  mainButon: {
    borderRadius: 6,
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    border: 'solid 1px #97c1ff',
    color: '#044ada',
    marginTop: 10,
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: 'white',
  },
  textoArquivo: {
    fontSize: 24,
    fontWeight: 500,
    color: 'black',
    opacity: 0.5,
  },
  quadradoTopoDireita: {
    position: 'absolute',
    right: 0,
    top: -62,
    width: 62,
    height: 62,
    backgroundColor: '#408bfc',
  },
  quadradoTopoEsquerda: {
    position: 'absolute',
    left: 0,
    top: -62,
    width: 62,
    height: 62,
    backgroundColor: '#408bfc',
  },
  quadradoEsquerdo: {
    position: 'absolute',
    left: -62,
    top: 0,
    width: 62,
    height: 62,
    backgroundColor: '#93bdfc',
  },
  quadradoDireita: {
    position: 'absolute',
    right: -62,
    bottom: 0,
    width: 62,
    height: 62,
    backgroundColor: '#408bfc',
  },
  quadradoBaixo: {
    position: 'absolute',
    right: 0,
    bottom: -62,
    width: 62,
    height: 62,
    backgroundColor: '#97c1ff',
  },
  imagemReplaceFoto: {
    width: 88,
    height: 88,
    backgroundColor: '#30b0ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'IBM Plex Sans',
    borderRadius: 44,
    marginBottom: 30,
  },
  campoTermoPosse: {
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 4,
    border: 'solid 1px #dfdfe6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nomeTermoPosse: {
    fontSize: 16,
    fontFamily: 'IBM Plex Sans',
    color: '#061243',
    margin: 0,
    padding: 0,
    paddingTop: 5,
  },
  nomeTermoPosseSpan: {
    fontSize: 12,
    fontFamily: 'IBM Plex Sans',
    color: '#5e6784',
    margin: 0,
    padding: 0,
    position: 'relative',
    top: -5,
  },
  tamanhoTermoPosse: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    color: '#5e6784',
    alignSelf: 'center',
    height: '100%',
    verticalAlign: 'center',
  },
  termoPosseLabels: {
    fontFamily: 'IBM PLex Sans',
    color: '#5e6784',
    fontWeight: 500,
    fontSize: 16,
  },
  retangulo: {
    backgroundColor: '#f7f7fa',
    marginTop: '8px',
    marginBottom: '8px',
  },
  imagem: {
    width: '75px',
    height: '72px',
    objectFit: 'contain',
    marginTop: '45px',
  }
});

export default useStyles;
